import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuthStore } from '@/stores/authStore';
/**
 * Gate for authenticated routes. If no access token is present in the
 * auth store, bounce to /login and stash the originally-requested path
 * in router state so the sign-in page can restore it after auth.
 *
 * Pair with <Outlet /> parents so the shell layouts sit behind this
 * guard, e.g. `<Route element={<RequireAuth />}><Route element={<PlatformShell/>}>...`.
 */
export function RequireAuth() {
    const accessToken = useAuthStore((s) => s.accessToken);
    const location = useLocation();
    if (!accessToken) {
        return _jsx(Navigate, { to: "/login", replace: true, state: { redirectTo: location.pathname + location.search } });
    }
    return _jsx(Outlet, {});
}
/**
 * Admin-only gate. Drops the user back to /login if they don't have
 * ADMIN or SUPER_USER. Matches the backend @PreAuthorize role checks on
 * the protected controllers.
 */
export function RequireAdmin() {
    const user = useAuthStore((s) => s.user);
    if (!user?.admin && !user?.superUser) {
        return _jsx(Navigate, { to: "/", replace: true });
    }
    return _jsx(Outlet, {});
}
/**
 * Admin OR billing-user gate. Used for /billing — matches the backend's
 * hasAnyRole('BILLING_USER','ADMIN','SUPER_USER') on /customerportal.
 */
export function RequireBillingOrAdmin() {
    const user = useAuthStore((s) => s.user);
    if (!user?.admin && !user?.superUser && !user?.billingUser) {
        return _jsx(Navigate, { to: "/", replace: true });
    }
    return _jsx(Outlet, {});
}
